import { checkUserStatusAndUpdateCensoredImagesRights } from "@modules/login-user/checkUserLoginStatus"
import { applyNotificationDots } from "./overall-user-notifications"
import "./user-menu"
import { appendMerkzettelForDevice, fetchMerkzettel } from "@modules/login-user/merkzettel.ts"

const FiveMinutesInMilliseconds = 1000 * 60 * 5
if (SiteInfo.accessToken !== "") {
    applyNotificationDots(SiteInfo.accessToken)
    checkUserStatusAndUpdateCensoredImagesRights(FiveMinutesInMilliseconds) //every 5 minutes
}

if (!SiteInfo.bookmarksPageActive) {
    // Checken ob cookie schon gesetzt worden ist
    const fetchMerkzettelCookieExists = document.cookie
        .split("; ")
        .some((cookie) => cookie.startsWith("CCMerkzettelFetched"))
    let cookieData = null

    if (userData.isLoggedIn && !fetchMerkzettelCookieExists) {
        fetchMerkzettel(SiteInfo.isMobileDevice)
    } else if (userData.isLoggedIn && fetchMerkzettelCookieExists) {
        cookieData = localStorage.getItem("CCMerkzettelData")
    }

    if (userData.isLoggedIn && cookieData !== null) {
        const parsedData = JSON.parse(cookieData)
        const merkzettelAdvertList = siteConfig.merkzettelIds

        if (merkzettelAdvertList.length !== parsedData.count) {
            fetchMerkzettel(SiteInfo.isMobileDevice)
        } else {
            appendMerkzettelForDevice(SiteInfo.isMobileDevice, parsedData)
        }
    }
}
